// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__oW7qb","errorLogs":"EditorFooter_errorLogs__2NsUS"};